module.exports = __webpack_public_path__ + "static/media/B45892NoticeofProposal-Amended.0b4ab346.pdf";